import { render, staticRenderFns } from "./addPeople.vue?vue&type=template&id=3117dfb8"
import script from "./addPeople.vue?vue&type=script&lang=js"
export * from "./addPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports